export const EXIT_CODE_SUCCESS = 0;
export const EXIT_CODE_GENERIC_ERROR = 1;
